import React from 'react';
import { IconProps } from '../types/types';

const XZC: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.9 117.9" role="img" {...props}><path d="M76.8 79.5H99v19.4H32.3l82.8-82.8c2.7-2.7 3.5-6.8 2.1-10.3-1.5-3.5-4.9-5.8-8.8-5.8H9.5C4.2 0 0 4.2 0 9.5v70l41.1-41.1H18.9V18.9h66.6L2.8 101.7C.1 104.4-.7 108.5.7 112c1.5 3.5 4.9 5.8 8.8 5.8h98.9c5.2 0 9.5-4.2 9.5-9.5V38.4L76.8 79.5z" style={{fill: '#23b852'}}/></svg>
);

export default XZC;
